import styled from '@emotion/styled';
import { colors } from '@modernanimal/common';

import { Tier } from './MembershipSelection';
import { CustomerMembershipTierEnum } from '../__generated__/graphql';
import Icons from '../icons';

const MembershipSelectionTable = (
    { membershipTiers, setIsCompareTableOpen }: {
        membershipTiers: Tier[];
        setIsCompareTableOpen: (isCompareTableOpen: boolean)=> void }
) => {
    const allAccessPlan = membershipTiers.find((tier) => tier.tier === CustomerMembershipTierEnum.AllAccess);
    const essentialsPlan = membershipTiers.find((tier) => tier.tier === CustomerMembershipTierEnum.Essential);
    const payAsYouGoPlan = membershipTiers.find((tier) => tier.tier === CustomerMembershipTierEnum.PayAsYouGo);

    return (
        <TableContainer>
            <Table>
                <TableHeader>
                    <HeaderRow>
                        <Cell>Membership</Cell>
                        <Cell align="center" color={colors.PRIMARY_PERIWINKLE}>
                            All Access
                        </Cell>
                        <Cell align="center" color={colors.PRIMARY_PERIWINKLE}>
                            Essential
                        </Cell>
                        <Cell align="center" color={colors.PRIMARY_PERIWINKLE}>
                            Pay as you go
                        </Cell>
                    </HeaderRow>
                </TableHeader>
                <TableBody>
                    <BodyRow>
                        <Cell>Exam fee</Cell>
                        <Cell align="center" color={colors.GREY_2}>
                            $0/visit
                        </Cell>
                        <Cell align="center" color={colors.GREY_2}>
                            1 free
                        </Cell>
                        <Cell align="center" color={colors.GREY_2}>
                            {`$${payAsYouGoPlan?.price}/visit`}
                        </Cell>
                    </BodyRow>
                    <BodyRow>
                        <Cell>Preferred booking</Cell>
                        <Cell align="center">
                            <IconWrapper>
                                <Icons.Check width={24} height={24} />
                            </IconWrapper>
                        </Cell>
                        <Cell align="center">
                            <IconWrapper>
                                <Icons.X width={24} height={24} fill={colors.RED} />
                            </IconWrapper>
                        </Cell>
                        <Cell align="center">
                            <IconWrapper>
                                <Icons.X width={24} height={24} fill={colors.RED} />
                            </IconWrapper>
                        </Cell>
                    </BodyRow>
                    <BodyRow>
                        <Cell>24/7 virtual care</Cell>
                        <Cell align="center">
                            <IconWrapper>
                                <Icons.Check width={24} height={24} />
                            </IconWrapper>
                        </Cell>
                        <Cell align="center">
                            <IconWrapper>
                                <Icons.Check width={24} height={24} />
                            </IconWrapper>
                        </Cell>
                        <Cell align="center">
                            <IconWrapper>
                                <Icons.X width={24} height={24} fill={colors.RED} />
                            </IconWrapper>
                        </Cell>
                    </BodyRow>
                    <BodyRow>
                        <Cell>Annual Cost</Cell>
                        <Cell align="center" color={colors.GREY_2}>
                            {`$${allAccessPlan?.price}`}
                        </Cell>
                        <Cell align="center" color={colors.GREY_2}>
                            {`$${essentialsPlan?.price}`}
                        </Cell>
                        <Cell align="center" color={colors.GREY_2}>
                            $0
                        </Cell>
                    </BodyRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MembershipSelectionTable;

const TableContainer = styled.div`
    width: 100%;
    max-width: 1024px;
    margin: 0 auto;
`;

const Table = styled.table`
    width: 100%;
    background-color: white;
    border-collapse: collapse;
`;

const TableHeader = styled.thead``;

const HeaderRow = styled.tr`
    border-bottom: 1px solid ${colors.PERIWINKLE_4};
    border-top: 1px solid ${colors.PERIWINKLE_4};
`;

const Cell = styled.th`
    text-align: ${(props) => props.align || 'left'};
    padding: 24px 24px 24px 0;
    color: ${(props) => props.color || colors.GREY_1};
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
`;

const TableBody = styled.tbody``;

const BodyRow = styled.tr`
    border-bottom: 1px solid ${colors.PERIWINKLE_4};
`;

const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;
